<template>
  <fragment>
    <AppBody
      title="Produtores / Gerenciar"
      subtitle="Produtores / Cadastrar - Editar"
    >
      <v-form ref="form" lazy-validation>
        <template v-if="$config.isAdmin()">
          <v-row>
            <v-col cols="8">
              <RegistrationData />
              <BankData />
              <Documents />
              <SharedNetwork />
            </v-col>
            <v-col cols="4">
              <Comission />
              <Theme />
              <Access />
              <Cashless />
            </v-col>
            <v-col cols="12">
              <AddictionalSettings />
            </v-col>
          </v-row>
        </template>
        <template v-else>
          <v-row>
            <v-col cols="8">
              <RegistrationData />
              <BankData />
            </v-col>
            <v-col cols="4">
              <Theme />
              <Cashless />
            </v-col>
            <v-col cols="12">
              <AddictionalSettings />
            </v-col>
          </v-row>
        </template>
      </v-form>
      <RegistrationActions
        :loader="$loja_gerenciar.cadastro.loading"
        :actions="actions"
        fixed
      />
    </AppBody>
    <ModalConfirmacao
      :textModal="$loja_gerenciar.text"
      :funcaoModal="$loja_gerenciar.funcao"
      @updateTable="$loja_gerenciar.funcaoRemover"
    />
    <FrequentlyQuestionsDialog />
    <SocialMediaDialog
      :redeEdit="$loja_gerenciar.social_media"
      :redeIdx="$loja_gerenciar.social_mediaIdx"
    />
    <ContactDialog
      :contatoEdit="$loja_gerenciar.contato"
      :contatoIdx="$loja_gerenciar.contatoIdx"
    />
    <ModalVisualizarImagem :image="$loja_gerenciar.visualizarImagem" />
    <ModalVisualizarPDF :pdf="$loja_gerenciar.visualizarPDF" />
  </fragment>
</template>

<script>
import AppBody from "@/layouts/components/AppBody.vue";
import RegistrationData from "@/components/lojas/RegistrationData.vue";
import Comission from "@/components/lojas/Comission.vue";
import BankData from "@/components/lojas/BankData.vue";
import Documents from "@/components/lojas/Documents.vue";
import Theme from "@/components/lojas/Theme.vue";
import SharedNetwork from "@/components/lojas/SharedNetwork.vue";
import AddictionalSettings from "@/components/lojas/AddictionalSettings/AddictionalSettings.vue";
import FrequentlyQuestionsDialog from "@/components/lojas/AddictionalSettings/FrequentlyQuestionsDialog.vue";
import SocialMediaDialog from "@/components/lojas/AddictionalSettings/SocialMediaDialog.vue";
import ContactDialog from "@/components/lojas/AddictionalSettings/ContactDialog.vue";
import ModalConfirmacao from "@/components/global/modal-confirmacao.vue";
import ModalVisualizarImagem from "@/components/global/modal-visualizar-imagem.vue";
import ModalVisualizarPDF from "@/components/global/modal-visualizar-pdf.vue";
import RegistrationActions from "@/components/global/RegistrationActions.vue";
import LojasGerenciarMixins from "@/mixins/Loja-Gerenciar.mixins.js";
import Access from "@/components/lojas/Access.vue";
import Cashless from "@/components/lojas/Cashless.vue";
export default {
  name: "ProducerSettings",
  metaInfo: {
    title: "Produtores | ElevenTickets",
    meta: [
      {
        property: "og:title",
        content: "Produtores | ElevenTickets",
      },
    ],
  },
  mixins: [LojasGerenciarMixins],
  components: {
    Comission,
    AppBody,
    RegistrationData,
    BankData,
    Documents,
    Theme,
    Access,
    Cashless,
    SharedNetwork,
    AddictionalSettings,
    RegistrationActions,
    ModalConfirmacao,
    FrequentlyQuestionsDialog,
    SocialMediaDialog,
    ContactDialog,
    ModalVisualizarImagem,
    ModalVisualizarPDF,
  },
  data() {
    return {
      tabStore: 0,
      actions: [
        {
          name: "Salvar",
          action: () => this.saveStore(),
        },
        {
          name: "Cancelar",
          action: () => this.cancelAction(),
        },
      ],
    };
  },
  computed: {
    routeType() {
      return this.$route.params.type;
    },
  },
  methods: {
    findFirstErrorField() {
      const fields = this.$refs.form.inputs;
      for (let i = 0; i < fields.length; i++) {
        // eslint-disable-next-line prettier/prettier, no-prototype-builtins
        if (fields[i].hasOwnProperty('errorBucket') && fields[i].errorBucket.length > 0) {
          return fields[i];
        }
      }
      return null;
    },
    saveStore() {
      const firstErrorField = this.findFirstErrorField();
      if (firstErrorField) {
        const yOffset = -30;
        const y =
          firstErrorField.$el.getBoundingClientRect().top +
          window.pageYOffset +
          yOffset;

        window.scrollTo({
          top: y,
          behavior: "smooth",
        });
      }

      if (this.$refs.form.validate()) {
        this.$loja_gerenciar.validarCadastro(this.routeType);
      }
    },
    cancelAction() {
      if (this.$axios.getLocal("oe_user_info")?.data?.user_type === "admin")
        return this.$router.push({
          name: "producers",
        });
      return (
        this.$router.push({
          name: "home",
        }),
        location.reload()
      );
    },
  },
  mounted() {
    this.$config.getBancos();
    this.$loja_segmentos.getSegmentos();
    this.$loja_gerenciar.getRegionais();
    this.$loja_gerenciar.getBandeirasAceitas();
    // if (this.$axios.getLocal("oe_user_info")?.data?.user_type === "admin") {
    //   this.$loja_gerenciar.getTipoTaxas();
    // }
    if (this.$route.params.type === "editar" && this.$route.params.id) {
      this.$loja_gerenciar.lojaAddOrEdit = "edit";
      this.$loja_gerenciar.getLoja(this.$route.params.id);
    }
  },
  destroyed() {
    this.$loja_gerenciar.limpaFormularioDeLoja();
  },
};
</script>
<style scoped></style>
